<template>
  <section class="views">
    <headers select="6"></headers>
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/h5banner_2025.jpg')"
      />
    </div>
    <!-- 活动回顾内容 -->
    <div class="event-review">
      <div class="event-container">
        <h1 class="review-title">
          第四屆「曾憲備·紫荊杯」全港少兒普通話朗誦比賽圓滿落幕
        </h1>
        <h2 class="review-title" style="margin-top: -10px">
          香港模式走向一帶一路
        </h2>

        <div class="review-content">
          <p class="text-paragraph">
            2025年7月5日，第四屆「曾憲備・紫荊盃」全港少兒普通話朗誦比賽的個人賽與團體賽決賽及頒獎典禮在羅定邦中學圓滿落幕。本屆比賽由曾憲備慈善基金、新界校長會及中文路（香港）有限公司聯合主辦，並得到了郭玲麗立法會議員辦事處、活力慈善基金、梨木樹苗趣社等單位的協辦支援。
          </p>
          <p class="text-paragraph">
            本屆 「曾憲備・紫荊盃」
            全港少兒普通話朗誦比賽，旨在為香港學生打造一個集文化傳承與語言提升於一體的舞台。通過用普通話朗誦中華經典作品，鼓勵學生們感受中文文本的美感，深入理解中華文化，同時提升普通話表達的流暢度與感染力，進而推動香港普通話教育事業的發展。
          </p>

          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_1.jpg')"
              alt="第四屆 「曾憲備・紫荊盃」大合影"
            />
            <p class="image-caption">第四屆 「曾憲備・紫荊盃」大合影</p>
          </div>

          <div class="section-title">
            <h2>豐富比賽賽制，滿足多元需求</h2>
          </div>

          <p class="text-paragraph">
            本屆比賽不僅設置了個人賽與團體賽兩大類別，還設置了「閃亮組」（面向特殊教育學校學生）和「飛躍組」（面向非華裔學生）等創新組別，旨在打造一個展示語言才華的多元化平台，以滿足學生在語言表達方面的不同成長需求。
          </p>
          <p class="text-paragraph">
            本次個人賽一共吸引了全港574所學校的5000多名學生的踴躍參與。個人賽不僅根據參賽學生的就讀年級細緻地劃分出六個組別，同時還專門設置了「閃亮組」和「飛躍組」以滿足不同類型學生的需求，八個組別每組最終各評選出金獎1名、銀獎2名、銅獎3名及優異獎4名。這種分層設計使得不同的學生都能在適合自己的組別中充分展示自己的風采。值得一提的是，本次比賽全新設立了面向非華裔學生的
            「飛躍組」，得到本港多間學校近50名非華裔學生的積極回應，他們憑藉獨特的語言背景和真摯的情感表達，為中文朗誦注入了鮮活的多元視角，充分展現了中文朗誦在跨文化交流中的獨特魅力與蓬勃生命力。
          </p>

          <!-- 添加四张图片轮播 -->
          <div class="carousel-container">
            <van-swipe
              class="carousel-swipe"
              :autoplay="3000"
              indicator-color="#d34a00"
            >
              <van-swipe-item
                v-for="(image, index) in carouselImages"
                :key="index"
              >
                <div class="carousel-item">
                  <img
                    :src="image.src"
                    :alt="image.alt"
                    class="carousel-image"
                  />
                  <p class="carousel-caption">{{ image.caption }}</p>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>

          <p class="text-paragraph">
            本次團體賽一共吸引了全港42所學校的近600名學生組隊積極參賽。團體賽按照學生的就讀年級劃分出四個組別，每組分別評選出金獎、銀獎、銅獎各1隊。團體賽聚焦於團隊協作與集體朗誦表現力的綜合展現，着重考察學生間的配合默契度、聲音層次豐富度以及整體情緒氛圍營造能力。團體賽為朗誦舞台注入了豐富多元的創意編排與風格各異的聲音演繹，生動呈現出普通話朗誦在集體協作中的獨特美感與無窮魅力。
          </p>
          <!-- 添加四张图片轮播 -->
          <div class="carousel-container">
            <van-swipe
              class="carousel-swipe"
              :autoplay="3000"
              indicator-color="#d34a00"
            >
              <van-swipe-item v-for="(image, index) in teamImages" :key="index">
                <div class="carousel-item">
                  <img
                    :src="image.src"
                    :alt="image.alt"
                    class="carousel-image"
                  />
                  <p class="carousel-caption">{{ image.caption }}</p>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>

          <div class="section-title">
            <h2>AI 賦能評審，提升比賽體驗</h2>
          </div>
          <p class="text-paragraph">
            在個人賽的初賽階段，本屆比賽再次引入中文路公司自主研發的AI普通話評估技術作為智能評審工具。該系統能夠在短時間內處理大量參賽音頻，並從普通話的聲母、韻母、聲調等多個維度精准分析選手的發音準確度與朗誦流暢度，實現自動化評分與表現反饋。這一技術的應用不僅顯著提升了評審效率與評分公平性，還借助大數據模型，精准識別參賽學生在語言學習中的薄弱環節，進而提供更具針對性的指導建議。在技術的賦能下，每一位參賽者都能直觀地看到自己的普通話學習成長軌跡，明確努力方向。
          </p>
          <p class="text-paragraph">
            除了AI語音評測技術，中文路還自研開發了AI中文自主學習系統，包括語音評測，場景對話、看圖說話和短講自訓等基於最先進AI技術開發的功能，主要服務香港中小學，讓中小學生根據自己的能力、興趣量身定制個性化學習方案。中文路董事長郭信麟先生表示，在未來還將不斷引入最新的技術助力于中文事業的發展。
          </p>

          <div class="image-container horizontal-images">
            <div class="image-item">
              <img
                class="review-image"
                :src="require('@/assets/image/eventReview/image_0_1.png')"
                alt="中文路AI語音評分系統"
              />
            </div>
            <div class="image-item">
              <img
                class="review-image"
                :src="require('@/assets/image/eventReview/image_0_2.jpg')"
                alt="中文路AI語音評分系統"
              />
            </div>
            <div class="image-item">
              <img
                class="review-image"
                :src="require('@/assets/image/eventReview/image_0_3.jpg')"
                alt="中文路AI語音評分系統"
              />
            </div>
          </div>
          <p
            style="
              text-align: center;
              font-size: 12px;
              color: #666;
              margin-top: 8px;
              font-style: italic;
            "
          >
            中文路AI語音評分系統
          </p>
          <div class="section-title">
            <h2>專業評審把關，彰顯朗誦美感</h2>
          </div>

          <p class="text-paragraph">
            個人賽決賽現場，監審儲安麗老師以及程梓龍、傅偉琴、袁立一、張海瑤（評審老師按姓氏首字母音序排名，排名不分先後）等老師組成的評審團親臨現場，從發音標準、節奏韻律、儀態舉止、情感處理、內容理解與整體表現力等多個維度，為選手們進行了專業的點評與指導。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_4.jpg')"
              alt="個人賽評審團合影"
            />
            <p class="image-caption">個人賽評審團合影</p>
          </div>
          <p class="text-paragraph">
            團體賽決賽現場，監審康一橋校長以及杜薇、金丹、汪丹、王菲（評審老師按姓氏首字母音序排名，排名不分先後）等老師組成的評審團對參賽選手的表現進行了綜合評分。評委們重點關注整體配合、朗誦節奏、集體表現力以及誦材編排設計等方面，最終決出各組別的優勝隊伍。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_5.png')"
              alt="團體賽評審精彩瞬間"
            />
            <p class="image-caption">團體賽評審精彩瞬間</p>
          </div>
          <div class="section-title">
            <h2>頒獎典禮見證，高光時刻閃耀</h2>
          </div>
          <p class="text-paragraph">
            頒獎典禮初，曾憲備慈善基金董事曾慶輝先生致歡迎辭，他首先向到場嘉賓、主禮官員、立法會議員、區議員、校長、老師以及同學們表示了熱烈歡迎與衷心感謝。接着，他感歎到本次比賽人數一舉突破5000人，體現了該比賽在香港地區的受歡迎程度之深。同時，他讚揚了AI技術在比賽中的應用，他認為最新的AI技術讓學生隨時隨地自主學習，將語言學習推上了全新的維度。曾先生強調掌握普通話對香港青少年融入大灣區、增強競爭力及建立文化自信至關重要，鼓勵同學們持續努力，以流利的普通話展現中華文化魅力。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_6.jpg')"
              alt="曾憲備慈善基金董事曾慶輝先生致歡迎辭"
            />
            <p class="image-caption">曾憲備慈善基金董事曾慶輝先生致歡迎辭</p>
          </div>

          <p class="text-paragraph">
            頒獎典禮上，行政會議成員、立法會議員、民建聯主席陳克勤先生（SBS,JP）和政制及內地事務局副局長胡健民先生（MH,JP）作為特邀嘉賓發表致辭。
          </p>
          <p class="text-paragraph">
            陳克勤先生動情地表示，當聽到在場的香港學生用活潑洪亮的聲音且發音清晰的普通話唱響國歌時，他深感欣慰與感動，並稱這次齊唱國歌是讓他印象最為深刻的一次。接着陳克勤先生表示，5000多名參賽者，意味著每位參賽者後面都站著數名為培養孩子說好普通話而付出巨大努力的師長，無論比賽的結果如何，都會增進家人之間的感情。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_7.jpg')"
              alt="行政會議成員、立法會議員、民建聯主席陳克勤先生致辭"
            />
            <p class="image-caption">
              行政會議成員、立法會議員、民建聯主席陳克勤先生致辭
            </p>
          </div>
          <p class="text-paragraph">
            胡建民先生首先向到場嘉賓和學生表示感謝，接着他指出普通話學習對香港小朋友意義重大，感謝相關機構為他們提供了學習普通話、了解國家文化的機會。他強調，在世界百年大變局中，香港應發揮好內聯外通的重要作用，並鼓勵同學們要通過學習普通話，進一步掌握國情，融入國家發展大局。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_8.jpg')"
              alt="政制及內地事務局副局長胡健民先生致辭"
            />
            <p class="image-caption">政制及內地事務局副局長胡健民先生致辭</p>
          </div>
          <p class="text-paragraph">
            頒獎典禮最後，中文路董事長郭信麟先生致感謝辭，他首先感謝了各位嘉賓以及中文路的同事。接着他指出中文路聯同新界校長會和郭玲麗立法會議員辦事處以香港數屆比賽的經驗和模式為藍本，利用AI技術助力，今年在印尼和泰國同樣舉辦了大型的中文（普通話）朗誦比賽，1800余名印尼學生和6600余名泰國學生分別參加了印尼和泰國的朗誦比賽，泰國的朗誦比賽更是被列為中泰建交50周年的官方紀念活動之一。這兩場海外朗誦比賽是用香港模式走向一帶一路的經典範例，再次證明香港作為中國國際城市的內聯外通作用。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_9.jpg')"
              alt="中文路董事長郭信麟先生致辭"
            />
            <p class="image-caption">中文路董事長郭信麟先生致辭</p>
          </div>
          <div class="section-title">
            <h2>嘉賓榮耀出席，點亮朗誦盛會</h2>
          </div>
          <p class="text-paragraph">
            本次頒獎典禮榮幸地邀請到了以下一些主禮嘉賓出席活動：行政會議成員、立法會議員、民建聯主席陳克勤先生（SBS,JP），政制及內地事務局副局長胡健民先生（MH,JP），中聯辦新界工作部宣教處副處長黃展豪先生，全國政協深圳市委員會委員、北區區議員、新社聯理事長譚鎮國先生（BBS,JP），立法會議員郭玲麗女士，教育局高級課程發展主任(中文)周健博士，新界校長會榮譽會長、大埔區區議員李細燕女士（BBS,JP），大埔區區議員胡綽謙先生。
          </p>
          <p class="text-paragraph">
            出席本次頒獎典禮的贊助及主辦機構代表有：曾憲備慈善基金董事曾慶輝先生，新界校長會會長朱景玄榮譽院士（SBS,
            BBS, MH,
            JP），新界校長會副主席兼羅定邦中學校長郭永強先生（BBS,MH,JP），中文路（香港）有限公司董事長郭信麟先生。
          </p>
          <p class="text-paragraph">
            出席本次頒獎典禮的合辦及支持機構代表有：民建聯，郭玲麗立法會議員辦事處郭玲麗議員，活力慈善基金鄭翔升副主席，梨木樹苗趣社劉松剛區議員，文冬漢語普通話中心黃綺琴女士，香港普通話專業協會會長兼西貢區區議員靳彤彤女士，香港國際青少兒交流協會會長潘劍鋒先生。
          </p>
          <p class="text-paragraph">
            這些重量級嘉賓的出席，不僅是對本次朗誦比賽的高度認可，更是對語言藝術傳承與發展的有力推動。他們的到來讓本次朗誦比賽熠熠生輝，每一位嘉賓都用自己的方式詮釋着對朗誦藝術的理解和熱愛，為活動注入了強大的精神動力，使其成為了一次難忘的文化盛事。
          </p>
          <p class="text-paragraph">
            本次比賽還要特別感謝以下組織機構和學校的付出與參與：民建聯、九龍地域校長聯會、香港島校長聯會、羅定邦中學、文冬漢語普通話中心、北京廣播電視台北京廣播影視培訓中心、香港浙江省同鄉會聯合會、香港福建社團聯會新界東北分會、香港普通話專業協會、朱偉林區議員辦事處、劉松剛區議員辦事處、靳彤彤區議員辦事處、李細燕區議員辦事處、邱少雄區議員辦事處、
            林翠玲區議員辦事處、周劍豪區議員辦事處、陳孟宜區議員辦事處、陳曉津區議員辦事處、香港國際青少兒交流協會和香港教師會。以上機構和學校對賽事的積極支援和對普通話推廣的貢獻讓本次比賽更加精彩。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_11.jpg')"
              alt="第四屆 「曾憲備・紫荊盃」大合影"
            />
            <p class="image-caption">第四屆 「曾憲備・紫荊盃」大合影</p>
          </div>

          <p class="text-paragraph">
            回首過去的四年，「紫荊盃」
            全港少兒普通話朗誦比賽已連續成功舉辦四屆。這四屆比賽見證了參賽學生數量的不斷增長和香港學生朗誦水平的穩步提升，也收穫了社會各界對賽事的廣泛認可與鼎力支持。普通話教育的推廣是一項長期而艱巨的任務，未來，中文路將繼續砥礪前行，探索創新路徑，結合先進的AI技術，助力學校提升普通話教學品質，培養更多優秀教師資源，為香港學生提供更優質的普通話學習體驗。期待
            「紫荊盃」
            能夠持續發揮其作為語言與文化橋樑的作用，激勵更多香港青少年熱愛普通話，增強語言自信，共同傳承和弘揚中華文化的博大精深。
          </p>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_list_1.png')"
              alt=""
            />
          </div>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_list_2.png')"
              alt=""
            />
          </div>
          <div class="image-container">
            <img
              class="review-image"
              :src="require('@/assets/image/eventReview/image_list_3.png')"
              alt=""
            />
            <p class="image-caption">第四屆個人/團體獲獎名單</p>
          </div>

          <!-- 媒体链接区域 -->
          <div class="media-links-section">
            <div class="media-links-title">
              <h2>媒體報道</h2>
            </div>
            <div class="media-links-container">
              <a
                href="https://www.takungpao.com/special/239159/2025/0707/1101796.html"
                target="_blank"
                class="media-link-item"
              >
                <span class="media-source">大公網：</span>
                <span class="media-title"
                  >第四届"曾宪备·紫荆杯"全港少儿普通话朗诵比赛圆满落幕——香港模式走向一带一路</span
                >
              </a>
              <a
                href="https://www.bastillepost.com/hongkong/article/15067178"
                target="_blank"
                class="media-link-item"
              >
                <span class="media-source">巴士的報：</span>
                <span class="media-title"
                  >第四屆「曾憲備‧紫荊盃」全港少兒普通話朗誦比賽圓滿結束</span
                >
              </a>
              <a
                href="http://www.gzdushiw.cn/xwzx/2255.html"
                target="_blank"
                class="media-link-item"
              >
                <span class="media-source">香港經濟新聞網：</span>
                <span class="media-title"
                  >第四屆"曾憲備·紫荊杯"全港少兒普通話朗誦比賽圓滿落幕——
                  香港模式走向一带一路</span
                >
              </a>
              <a
                href="https://www.capital-hk.com/topics/news_02_06072025"
                target="_blank"
                class="media-link-item"
              >
                <span class="media-source">CAPITAL：</span>
                <span class="media-title"
                  >第四屆「曾憲備·紫荊盃」全港少兒普通話朗誦比賽（個人賽及團體賽）圓滿舉行
                  冀提升學生愛國情感</span
                >
              </a>
              <a
                href="https://www.dab.org.hk/post/%E7%AC%AC%E5%9B%9B%E5%B1%86%E3%80%8C%E6%9B%BE%E6%86%B2%E5%82%99-%E7%B4%AB%E8%8D%8A%E7%9B%83%E3%80%8D%E5%85%A8%E6%B8%AF%E5%B0%91%E5%85%92%E6%99%AE%E9%80%9A%E8%A9%B1%E6%9C%97%E8%AA%A6%E6%AF%94%E8%B3%BD%EF%BC%88%E5%80%8B%E4%BA%BA%E8%B3%BD%E5%8F%8A%E5%9C%98%E9%AB%94%E8%B3%BD%EF%BC%89%E5%9C%93%E6%BB%BF%E8%88%89%E8%A1%8C-%E5%86%80%E6%8F%90%E5%8D%87%E5%AD%B8%E7%94%9F%E6%84%9B%E5%9C%8B%E6%83%85%E6%84%9F"
                target="_blank"
                class="media-link-item"
              >
                <span class="media-source">DAB Official Site：</span>
                <span class="media-title"
                  >第四屆「曾憲備·紫荊盃」全港少兒普通話朗誦比賽（個人賽及團體賽）圓滿舉行
                  冀提升學生愛國情感</span
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/h_header";
const isIOS = /(iPhone|iPad|iPod|iOS)/.test(navigator.userAgent);
export default {
  name: "views",
  data() {
    return {
      teamImages: [
        {
          src: require("@/assets/image/eventReview/image_3_1.jpg"),
          alt: "比賽現場照片1",
          caption: "團體賽學生精彩瞬間",
        },
        {
          src: require("@/assets/image/eventReview/image_3_2.jpg"),
          alt: "比賽現場照片2",
          caption: "團體賽學生精彩瞬間",
        },
        {
          src: require("@/assets/image/eventReview/image_3_3.jpg"),
          alt: "比賽現場照片3",
          caption: "團體賽學生精彩瞬間",
        },
        {
          src: require("@/assets/image/eventReview/image_3_4.jpg"),
          alt: "比賽現場照片4",
          caption: "團體賽學生精彩瞬間",
        },
      ],
      carouselImages: [
        {
          src: require("@/assets/image/eventReview/image_2_1.png"),
          alt: "比賽現場照片1",
          caption: "個人賽學生精彩瞬間",
        },
        {
          src: require("@/assets/image/eventReview/image_2_2.png"),
          alt: "比賽現場照片2",
          caption: "個人賽學生精彩瞬間",
        },
        {
          src: require("@/assets/image/eventReview/image_2_3.png"),
          alt: "比賽現場照片3",
          caption: "個人賽學生精彩瞬間",
        },
        {
          src: require("@/assets/image/eventReview/image_2_4.png"),
          alt: "比賽現場照片4",
          caption: "個人賽學生精彩瞬間",
        },
      ],
    };
  },
  computed: {},
  components: {
    headers,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: linear-gradient(225deg, #ff8310 0%, #fe840f 100%);
}
.posters {
  width: 100%;
  display: flex;
  position: relative;
  img {
    width: 100%;
  }
}
.event-review {
  width: 100%;
  padding: 0 0 15px 0;

  .event-container {
    width: 92%;
    margin: 0 auto;
    padding: 15px;
    background-color: #fff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .review-title {
    font-size: 20px;
    color: #d34a00;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
    line-height: 1.4;
  }

  .section-title {
    margin: 25px auto;
    width: 85%;
    padding: 10px;
    border: 2px solid #d34a00;
    border-radius: 8px;
    background: linear-gradient(
      to right,
      rgba(255, 120, 47, 0.1),
      rgba(255, 120, 47, 0.05)
    );
    position: relative;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

    &::before,
    &::after {
      content: "";
      position: absolute;
      width: 15px;
      height: 15px;
      border-style: solid;
      border-color: #d34a00;
    }

    &::before {
      top: -5px;
      left: -5px;
      border-width: 3px 0 0 3px;
      border-radius: 5px 0 0 0;
    }

    &::after {
      bottom: -5px;
      right: -5px;
      border-width: 0 3px 3px 0;
      border-radius: 0 0 5px 0;
    }

    h2 {
      margin: 0;
      color: #d34a00;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  .review-content {
    .text-paragraph {
      font-size: 14px;
      line-height: 1.7;
      color: #333;
      margin-bottom: 15px;
      text-indent: 2em;
      text-align: justify;
    }

    .carousel-container {
      margin: 20px auto;
      width: 100%;

      .carousel-swipe {
        height: 280px;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

        .carousel-item {
          height: 100%;
          display: flex;
          flex-direction: column;
          position: relative;

          .carousel-image {
            width: 100%;
            height: 230px;
            object-fit: cover;
            border-radius: 8px 8px 0 0;
          }

          .carousel-caption {
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: rgba(255, 120, 47, 0.05);
            color: #d34a00;
            font-size: 14px;
            margin: 0;
          }
        }
      }
    }

    .carousel-container ::v-deep .van-swipe__indicator {
      width: 8px;
      height: 8px;
      background-color: rgba(211, 74, 0, 0.3);
      opacity: 1;

      &--active {
        background-color: #d34a00;
      }
    }

    .image-container {
      margin: 20px 0;
      text-align: center;

      .review-image {
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      }

      .image-caption {
        font-size: 12px;
        color: #666;
        margin-top: 8px;
        font-style: italic;
      }
    }

    .horizontal-images {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
    }

    .horizontal-images .image-item {
      flex: 1;
    }

    .horizontal-images .image-item .review-image {
      width: 100%;
      height: auto;
      max-width: 100%;
    }

    .media-links-section {
      margin: 30px 0;

      .media-links-title {
        text-align: center;
        margin-bottom: 15px;

        h2 {
          font-size: 18px;
          color: #d34a00;
          font-weight: bold;
          position: relative;
          display: inline-block;

          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            bottom: -5px;
            left: 0;
            background: linear-gradient(
              to right,
              rgba(255, 120, 47, 0),
              rgba(255, 120, 47, 1),
              rgba(255, 120, 47, 0)
            );
          }
        }
      }

      .media-links-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .media-link-item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          width: 90%;
          max-width: 600px;
          padding: 10px;
          margin: 10px 0;
          border: 1px solid #d34a00;
          border-radius: 8px;
          background-color: rgba(255, 120, 47, 0.1);
          text-decoration: none;
          color: #333;
          transition: transform 0.3s, box-shadow 0.3s;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }

          .media-source {
            font-size: 14px;
            font-weight: bold;
            color: #d34a00;
            margin-bottom: 5px;
          }

          .media-title {
            font-size: 16px;
            line-height: 1.4;
            text-align: left;
          }
        }
      }
    }
  }
}

// 媒体查询优化小屏幕
@media screen and (max-width: 360px) {
  .event-review {
    .review-title {
      font-size: 18px;
    }

    .section-title h2 {
      font-size: 16px;
    }

    .review-content .text-paragraph {
      font-size: 13px;
      line-height: 1.6;
    }

    .carousel-container .carousel-swipe {
      height: 250px;

      .carousel-item .carousel-image {
        height: 200px;
      }
    }
  }
}

// 优化iPhone X及以上设备底部安全区域
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .views {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
